function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* global newrelic */
export const rental = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('rental-api-sources.error', _ref => {
    let {
      output
    } = _ref;
    if (typeof newrelic !== 'undefined') {
      newrelic.addPageAction('RentalApiError', output);
    }
  });
  window.LIFE_CYCLE_EVENT_BUS.on('rental-api-sources.success', _ref2 => {
    let {
      output
    } = _ref2;
    if (typeof newrelic !== 'undefined') {
      newrelic.addPageAction('RentalApiSuccess', output);
    }
  });
  window.LIFE_CYCLE_EVENT_BUS.on('rental-reservation-form.add-to-cart', _ref3 => {
    let {
      output
    } = _ref3;
    if (typeof newrelic !== 'undefined') {
      const {
        cartReqParams,
        path
      } = output;
      if (cartReqParams) {
        newrelic.addPageAction('RentalAddToCart', _objectSpread(_objectSpread({}, cartReqParams), {}, {
          domPath: (path || []).join('>')
        }));
      }
    }
  });
};
//# sourceMappingURL=rental.listener.js.map